import { errorMsg } from '../../utils/errorMsg';
import React, { useState, useEffect } from 'react';
import {
  Container, Typography, Box, Chip, CircularProgress, Alert,
  Card, CardContent, Grid, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Paper
} from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import GroupIcon from '@mui/icons-material/Group';
import { meusDiscipulados, meuDiscipulador } from '../../api/discipulado';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import ContextNavBar from '../../components/ContextNavBar';
import ModuleHeader from '../../components/ModuleHeader';

const STATUS_COLOR = {
  ativo: 'success', pausado: 'warning', concluido: 'info', cancelado: 'error'
};
const STATUS_LABEL = {
  ativo: 'Ativo', pausado: 'Pausado', concluido: 'Concluído', cancelado: 'Cancelado'
};

function MeuDiscipulado() {
  const [discipulador, setDiscipulador] = useState(null);
  const [discipulados, setDiscipulados] = useState([]);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState('');

  useEffect(() => {
    setLoading(true);
    setErro('');
    Promise.all([
      meuDiscipulador().catch(() => null),
      meusDiscipulados().catch(() => [])
    ])
      .then(([discipuladorData, discipuladosData]) => {
        setDiscipulador(discipuladorData);
        setDiscipulados(discipuladosData);
      })
      .catch((err) => {
        setErro(errorMsg(err) || 'Erro ao carregar dados');
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <>
        <Header />
        <ContextNavBar context="discipulado" />
        <Container maxWidth="md" sx={{ py: { xs: 2, md: 4 }, px: { xs: 1, md: 2 } }}>
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}><CircularProgress /></Box>
        </Container>
        <Footer />
      </>
    );
  }

  if (erro) {
    return (
      <>
        <Header />
        <ContextNavBar context="discipulado" />
        <Container maxWidth="md" sx={{ py: { xs: 2, md: 4 }, px: { xs: 1, md: 2 } }}>
          <Alert severity="error">{erro}</Alert>
        </Container>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Header />
      <ContextNavBar context="discipulado" />
      <Container maxWidth="md" sx={{ py: { xs: 2, md: 4 }, px: { xs: 1, md: 2 } }}>
        <Typography variant="h4" sx={{ fontWeight: 800, mb: 3, fontSize: { xs: '1.2rem', md: '1.5rem' } }}>Meu Discipulado</Typography>

        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Card elevation={1} sx={{ borderRadius: 2 }}>
              <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                  <PersonIcon color="primary" />
                  <Typography variant="h6" sx={{ fontWeight: 700 }}>Meu Discipulador</Typography>
                </Box>
                {discipulador ? (
                  <Box>
                    <Typography variant="body1" sx={{ fontWeight: 600 }}>{discipulador.nome || discipulador.discipulador_nome || '—'}</Typography>
                    <Box sx={{ mt: 1 }}>
                      <Chip
                        label={STATUS_LABEL[discipulador.status] || discipulador.status || 'Ativo'}
                        color={STATUS_COLOR[discipulador.status] || 'success'}
                        size="small"
                      />
                    </Box>
                    {discipulador.observacoes && (
                      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>{discipulador.observacoes}</Typography>
                    )}
                  </Box>
                ) : (
                  <Typography variant="body2" color="text.secondary">Você não possui um discipulador vinculado.</Typography>
                )}
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={6}>
            <Card elevation={1} sx={{ borderRadius: 2 }}>
              <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                  <GroupIcon color="primary" />
                  <Typography variant="h6" sx={{ fontWeight: 700 }}>Meus Discipulandos</Typography>
                </Box>
                {discipulados.length === 0 ? (
                  <Typography variant="body2" color="text.secondary">Você não possui discipulandos.</Typography>
                ) : (
                  <TableContainer component={Paper} elevation={0} sx={{ mt: 1, overflowX: 'auto' }}>
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell sx={{ fontWeight: 700, whiteSpace: 'nowrap' }}>Nome</TableCell>
                          <TableCell sx={{ fontWeight: 700, whiteSpace: 'nowrap' }}>Status</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {discipulados.map(d => (
                          <TableRow key={d.id} hover>
                            <TableCell>
                              <Typography variant="body2" sx={{ fontWeight: 600 }}>{d.discipulando_nome || '—'}</Typography>
                            </TableCell>
                            <TableCell>
                              <Chip label={STATUS_LABEL[d.status] || d.status} color={STATUS_COLOR[d.status] || 'default'} size="small" />
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
      <Footer />
    </>
  );
}

export default MeuDiscipulado;
